// extracted by mini-css-extract-plugin
export default {"headerWrapper":"style_headerWrapper__tvZX8","small":"style_small__H-djH","theme":"style_theme__1xcNO"};